const initialState = {
    plans: [],
    loading: false,
    error: null,
  };
  
  const planReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_PLANS_REQUEST":
        return { ...state, loading: true, error: null };
      case "FETCH_PLANS_SUCCESS":
        return { ...state, loading: false, plans: action.payload };
      case "FETCH_PLANS_FAILURE":
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  export default planReducer;
  